import React from 'react';
import { SpeciesVisual } from './SpeciesVisual';

export const SpeciesLeftImage = ({ down_type, origin }) => {
  return (
    <SpeciesVisual down_type={down_type} origin={origin} lower="left" />
  );
};